import { Component, Input, SimpleChanges } from '@angular/core';
import { Timeline } from 'primeng/timeline';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { AddNoteComponent } from "../add-note/add-note.component";
import { DeleteTimelineActionComponent } from "../delete-timeline-action/delete-timeline-action.component";
import { LeadService } from 'src/app/private/services/lead.service';
import { MessageService } from 'primeng/api';
import { NoteService } from 'src/app/private/services/micro-services/note.service';
import { TaskService } from 'src/app/private/services/micro-services/task.service';
import { LeadTaskComponent } from "../lead-task/lead-task.component";

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-lead-timeline',
  imports: [Timeline, SharedModule, AddNoteComponent, DeleteTimelineActionComponent, LeadTaskComponent],
  templateUrl: './lead-timeline.component.html',
  styleUrl: './lead-timeline.component.scss'
})
export class LeadTimelineComponent {
  events: any[] = [];
  @Input() title: string = 'Activity Timeline';
  @Input() timelineData: any[] = [];
  @Input() isUpdate: boolean = false;
  @Input() isDelete: boolean = false;

  @Input() isDocumentTimeline: boolean = false;

  opnModelDialogValue: any;
  selectedEvent: any;

  openDeleteDialog: boolean = false;
  deleteLoading: boolean = false;
  deleteTitle: string = 'Delete Timeline';
  deleteDescription: string = 'Are you sure you want to delete this timeline?';

  constructor(
    private api: LeadService,
    private messageService: MessageService,
    private noteService: NoteService,
    private taskService: TaskService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['timelineData'] && changes['timelineData'].currentValue != changes['timelineData'].previousValue) {
      if (this.timelineData?.length > 0) {
        this.events = this.timelineData;
      } else {
        this.events = [];
      }
    }
  }

  getInitials(name: string) {
    if (!name) return "GR";
    const initialName = name.split(' ').map(n => n[0]).join('');
    return initialName.length > 2 ? initialName.slice(0, 2) : initialName;
  }

  handleEditTimeline(event: any) {
    if (this.title == 'Notes Timeline') {
      this.opnModelDialogValue = 'editNote';
      this.selectedEvent = event;
    } else if (this.title == 'Task Timeline') {
      this.opnModelDialogValue = 'editTask';
      this.selectedEvent = event;
    }
  }

  handleDeleteTimeline(event: any) {
    this.openDeleteDialog = true;
    this.selectedEvent = event;

    if (this.title == 'Notes Timeline') {
      this.deleteTitle = 'Delete Note';
      this.deleteDescription = 'Are you sure you want to delete this note?';
    } else if (this.title == 'Task Timeline') {
      this.deleteTitle = 'Delete Task';
      this.deleteDescription = 'Are you sure you want to delete this task?';
    } else if (this.title == 'Document Timeline' || this.isDocumentTimeline) {
      this.deleteTitle = 'Delete Document';
      this.deleteDescription = 'Are you sure you want to delete this document?';
    }
  }

  handleCloseDIalog() {
    this.opnModelDialogValue = '';
    this.openDeleteDialog = false;
  }

  handleDeleteTimelineEvent() {
    if (this.title == 'Notes Timeline') this.handleDeleteNote();
    else if (this.title == 'Task Timeline') this.handleDeleteTask();
    else if (this.title == 'Document Timeline' || this.isDocumentTimeline) this.handleDeleteDocument();
  }

  handleDeleteNote() {
    this.deleteLoading = true;
    this.api.deleteLeadNote({ id: this.selectedEvent.id }).subscribe({
      next: data => {
        this.deleteLoading = false;
        this.events = this.events.filter((event: any) => event.id != this.selectedEvent.id);
        this.noteService.setTasks(this.events);
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Note deleted successfully' });
        this.openDeleteDialog = false;
      },
      error: error => {
        this.deleteLoading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete note' });
      }
    });
  }

  handleDeleteTask() {
    this.deleteLoading = true;
    this.api.deleteLeadTask({ id: this.selectedEvent.id }).subscribe({
      next: data => {
        this.events = this.events.filter((event: any) => event.id != this.selectedEvent.id);
        this.taskService.setTasks(this.events);
        this.deleteLoading = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Task deleted successfully' });
        this.openDeleteDialog = false;
      },
      error: error => {
        this.deleteLoading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete task' });
      }
    });
  }

  handleDeleteDocument() {
    this.deleteLoading = true;
    const payload = { id: [this.selectedEvent.id] };
    this.api.deleteLeadDocument(payload).subscribe({
      next: data => {
        this.events = this.events.filter((event: any) => event.id != this.selectedEvent.id);
        this.deleteLoading = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Document deleted successfully' });
        this.openDeleteDialog = false;
      },
      error: error => {
        this.deleteLoading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete document' });
      }
    });
  }

  // In your component.ts file

  // In your component.ts file

  /**
   * Formats a raw string into human-readable HTML, handling both
   * structured key-value pairs and unstructured messages.
   * @param rawString The string to be formatted.
   * @returns A single string containing formatted HTML.
   */
  formatDescription(rawString: string): SafeHtml {
  const parts = rawString.split(',');
  
  const formattedParts = parts.map(part => {
    const trimmed = part.trim();

    // replace all single-quoted text with bold
    const replaced = trimmed.replace(/'([^']+)'/g, '<b>$1</b>');

    return `<li>${replaced}</li>`;
  });

  return this.sanitizer.bypassSecurityTrustHtml(`<ul>${formattedParts.join('')}</ul>`);
}

}
